// extracted by css-extract-rspack-plugin
export default {"cls1":"NewCitationPing-cls1_uHn","cls2":"NewCitationPing-cls2_Thh NewCitationPing-cls1_uHn"};